// eslint-disable-next-line import/no-relative-parent-imports
import messages from '../../../../../translations/messages_front.fr.json';
// eslint-disable-next-line import/no-relative-parent-imports
import validators from '../../../../../translations/validators.fr.json';

export const translations = {
  messages: messages as Record<string, string>,
  validators: validators as Record<string, string>,
};
